import './WidgetList.scss';

import Control from "../../1. Core/Control";
import Delegate from "../../1. Core/Delegate";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import NP from "../../1. Core/NP";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";

//let moment = require('moment');

import {ServerAPI} from "../../1. Core/ServerAPI";
import Menu from "../../1. Core/Controls/Menu/Menu";
import ChooseTemplateWidgetDialog from "./ChooseTemplateWidgetDialog";
import {Widget, WidgetMetadata} from "../types";
import {WidgetType, WLIST} from "./WEnum";
import DataTable from "../../1. Core/Controls/DataTable/DataTable";


export default class WidgetList extends Control {
	private _topAppBar: TopAppBar;
	private EvShowPageModeClick: Delegate;
	private _dataTable: DataTable;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this.EvShowPageModeClick = new Delegate();
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();
		this.addClass('');

		this._topAppBar = new TopAppBar({
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: 'Widgets',
			ParentNode: this._root,
			ShowSearchButton: false,
			MainButton: {
				FontImage: NP.FontImages.menu,
				EvClick: () => this.EvShowPageModeClick.fire(this)
			},
			RightItems: NP.getCurrentUser().isBDAdmin() ? [
				new IconToggleButton({
					FontImage: NP.FontImages.add,
					EvClick: () =>
					{
						(new ChooseTemplateWidgetDialog({
							EvOkButtonClick: () => this.refreshList()
						})).show()
					}
				})
			] : []
		});

		//this._listNode = NP.createNode(this._root, 'widget-list-node');

		this._dataTable = new DataTable({
			ParentNode: this._root,
			Class: 'mdc-data-table--margin data-table-battle',
			ShowSettingsButton: true,
			MultiSelect: false,
			ShowRowIndex: true,
			ImageWidth: 32,
			Columns: [{
				Content: NP.RM.getString('Name'),
				PropertyContent: 'Name',
				Width: '25%'
			}, {
				Content: 'Type',
				PropertyContent: 'Type',
				Width: '25%'
			}, {
				Content: '',
				PropertyContent: '',
				Width: '25%'
			}, {
				Content: NP.RM.getString('Date'),
				PropertyContent: 'Created',
				Type: 'Date',
				Width: '25%'
			}],
			ShowPaginator: false,
			EvItemClick: (s: any, e: { Event: any, Item: Widget<WidgetMetadata> }) =>
			{
				(new Menu({
					Items: this.getMenuItems(e.Item)
				})).showContextMenu(e.Event);
			},
			EvItemContextMenu: async (s: any, e: { Event: any, Item: Widget<WidgetMetadata> }) =>
			{
				(new Menu({
					Items: this.getMenuItems(e.Item)
				})).showContextMenu(e.Event);
			}
		});
	}

	getMenuItems(widget: Widget<WidgetMetadata>)
	{
		switch (widget.Metadata.WId)
		{
			case WidgetType.EventStat:
				return [{
					FontImage: NP.FontImages.link,
					Content: NP.RM.getString('Open') + '-1x1',
					Value: 'Open1x1',
					EvClick: () => window.open(`/cwidget/event-stat?id=${widget.Id}&lang=${NP.getCurrentCulture().Name}`)
				}, {
					FontImage: NP.FontImages.link,
					Content: NP.RM.getString('Open') + '-9x16',
					Value: 'Open9x16',
					EvClick: () => window.open(`/cwidget/event-stat?id=${widget.Id}&lang=${NP.getCurrentCulture().Name}&mode=9x16`)
				}, {
					FontImage: NP.FontImages.link,
					Content: NP.RM.getString('Open') + '-16x9',
					Value: 'Open16x9',
					EvClick: () => window.open(`/cwidget/event-stat?id=${widget.Id}&lang=${NP.getCurrentCulture().Name}&mode=16x9`)
				}, {IsSeparator: true}, ...this.getStandardItems(widget)];

			case WidgetType.FighterStat:
				return [{
					FontImage: NP.FontImages.link,
					Content: NP.RM.getString('Open'),
					Value: 'Open',
					EvClick: () => window.open(`/cwidget/fighter-stat?id=${widget.UrlId}&lang=${NP.getCurrentCulture().Name}`)
				}, {IsSeparator: true}, ...this.getStandardItems(widget)]

			case WidgetType.OnlineText:
				return [{
					FontImage: NP.FontImages.link,
					Content: NP.RM.getString('Open'),
					Value: 'Open',
					EvClick: () => window.open(`/cwidget/online-text?id=${widget.UrlId}&lang=${NP.getCurrentCulture().Name}`)
				}, {IsSeparator: true}, ...this.getStandardItems(widget)]

			case WidgetType.FighterCompareStat:
				return [{
					FontImage: NP.FontImages.link,
					Content: NP.RM.getString('Open'),
					Value: 'Open',
					EvClick: () => window.open(`/cwidget/fighter-compare-stat?id=${widget.UrlId}&lang=${NP.getCurrentCulture().Name}`)
				}, {IsSeparator: true}, ...this.getStandardItems(widget)]

			case WidgetType.FighterCompare:
				return [{
					FontImage: NP.FontImages.link,
					Content: NP.RM.getString('Open'),
					Value: 'Open',
					EvClick: () => window.open(`/cwidget/fighter-compare?id=${widget.UrlId}&lang=${NP.getCurrentCulture().Name}`)
				}, {IsSeparator: true}, ...this.getStandardItems(widget)]

			case WidgetType.FighterRecord:
				return [{
					FontImage: NP.FontImages.link,
					Content: NP.RM.getString('Open'),
					Value: 'Open',
					EvClick: () => window.open(`/cwidget/fighter-record?id=${widget.UrlId}&lang=${NP.getCurrentCulture().Name}`)
				}, {IsSeparator: true}, ...this.getStandardItems(widget)]
			case WidgetType.FighterCard:
				return [{
					FontImage: NP.FontImages.link,
					Content: NP.RM.getString('Open'),
					Value: 'Open',
					EvClick: () => window.open(`/cwidget/fighter-card?id=${widget.UrlId}&lang=${NP.getCurrentCulture().Name}`)
				}, {IsSeparator: true}, ...this.getStandardItems(widget)]
		}
	}

	getStandardItems(widget: Widget<WidgetMetadata>)
	{
		return [{
			FontImage: NP.FontImages.edit,
			RK: 'Edit',
			Value: 'Edit',
			EvClick: () => this.editItem(widget)
		}, {
			FontImage: NP.FontImages.cut,
			Content: NP.RM.getString('Duplicate'),
			Value: 'Open',
			EvClick: async () =>
			{
				await ServerAPI.post(`/widget/duplicate/${widget.Id}`);
				this.refresh()
			}
		}, {
			FontImage: NP.FontImages.delete,
			RK: 'Delete',
			Value: 'Delete',
			EvClick: () => this.onDeleteSelected(widget)
		}]
	}

	onDeleteSelected(widget: Widget<WidgetMetadata>)
	{
		NP.showConfirm({
			RK: 'AreYouS',
			EvOkButtonClick: async () =>
			{
				await ServerAPI.callUiApi(`/widget/${widget.Id}`, null, 'DELETE');
				this.refreshList();
			}
		}).show();
	}

	onListContextMenu(e: any, widget: Widget<WidgetMetadata>)
	{
		let menu = new Menu({
			Items: this.getMenuItems(widget)
		});
		menu.showContextMenu(e);
	}

	editItem(w: Widget<WidgetMetadata>)
	{
		(new WLIST[w.Metadata.WId].Class({
			EvOkButtonClick: () => this.refreshList(),
			Widget: w,
		})).show()
	}

	refresh()
	{
		this.refreshList();
	}


	private async refreshList()
	{
		this._dataTable.setRows([]);
		let items = await ServerAPI.callUiApi("/widget") as Widget<WidgetMetadata>[]


		this._dataTable.setRows(items.map(ev => ({
			...ev,
			//CreatedStr: moment(ev.Created).format(NP.getDayFormat()),
			Type: ev.Metadata.WId
		})));

	}

	_getContentHeight()
	{
		return this._Height - this._topAppBar.getOffsetHeight();
	}

	setHeight(value: number)
	{
		super.setHeight(value);
		let h = this._getContentHeight();
		this._dataTable.setHeight(h);
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this._dataTable.setWidth(value);

	}

	getTopAppBar()
	{
		return this._topAppBar;
	}
}